<script setup>
import { usePageHead } from '@composables/use-page-head'
import Logo from '@components/logo'

usePageHead({ title: 'Account Management', description: 'Account Management' })
</script>

<template>
    <Logo/>
    <router-view class="router-content"/>
</template>

<style lang="scss" scoped>
@import '@design';

.router-content {
    margin-top: $s-xl;
}

@include tablet {
    .router-content {
        margin-top: $s-xxl;
    }
}

@include desktop {
    .router-content {
        margin-top: $s-h;
    }
}
</style>
